import { FC, useCallback, useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@features/ui';
import { EditorComponent } from '@features/admin/emails/EditorComponent.tsx';

interface AddNotePopupProps {
  open: boolean;
  title?: string;
  noteEdit?: string | null;
  onOpenChange: (open: boolean) => void;
  onConfirm: (value: string) => void;
}
export const AddNotePopup: FC<AddNotePopupProps> = ({
  open,
  title,
  noteEdit,
  onOpenChange,
  onConfirm,
}) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (noteEdit) {
      setValue(noteEdit);
    }
  }, [noteEdit]);

  const handleOpenChange = useCallback(
    (open: boolean) => {
      setValue('');
      onOpenChange(open);
    },
    [onOpenChange]
  );

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-[23px] mb-[23px]">
            {title ?? `${!noteEdit ? 'Add Note' : 'Edit Note'}`}
          </DialogTitle>
        </DialogHeader>
        <div>
          <EditorComponent
            toolbar={{
              options: ['inline'],
              inline: {
                options: ['bold', 'italic', 'underline'],
              },
            }}
            value={value}
            onChange={setValue}
          />
        </div>
        <DialogFooter>
          <div className="flex items-center gap-10">
            <Button
              className={'w-20'}
              size={'sm'}
              variant={'secondary'}
              onClick={() => {
                handleOpenChange(false);
                setValue('');
                onConfirm(value);
              }}
            >
              Save
            </Button>
            <Button
              className={'w-20'}
              size={'sm'}
              onClick={() => handleOpenChange(false)}
            >
              Cancel
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
